module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJ0lEQVQ4y2NgGBTgi4b5f2QMA+ji6Hg4GfCfTEA9A0ZjgQoGDG0AAJaqsfByPX3/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/DK.png
// module id = 1124
// module chunks = 0